import Journal from "@/src/_types/journal";


/**
 * Returns the directory path for a given journal.
 * @param journal - The journal object containing metadata.
 * @returns The directory path for the journal.
 */
export function getJournalDirectory(journal: Journal): string {
    const titleAbbr = journal.meta_data?.title_abbr || 'default';
    return `${process.cwd()}/public/journals/${titleAbbr}/`;
}

/**
 * Returns the directory path for a specific issue of a journal.
 * @param journal - The journal object containing metadata.
 * @param issueId - The ID of the issue.
 * @returns The directory path for the issue.
 */
export function getIssueDirectory(journal: Journal, issueId: number): string {
    const baseDir = getJournalDirectory(journal);
    return `${baseDir}issue/${issueId}`;
}

/**
 * Generates the link to access a specific issue of the journal.
 *
 * @param journal - The journal object containing the journal's URL.
 * @param issueId - The ID of the issue for which the link is being generated.
 * @returns The URL string to access the specified issue of the journal.
 */
export function getIssueLink(journal: Journal, issueId: number): string {
    return `${journal.journal_url}/issue/${issueId}`;
}

/**
 * Generates the download link for the XML file of a specific issue of the journal.
 *
 * @param journal - The journal object containing the journal's URL.
 * @param issueId - The ID of the issue for which the XML download link is being generated.
 * @returns The URL string to download the XML file of the specified issue of the journal.
 */
export function getXmlIssueDownloadLink(journal: Journal, issueId: number): string {
    return `${getIssueLink(journal, issueId)}.xml`;
}
